module.exports = __webpack_public_path__ + "img/background2-mobile-hk.55ee32b2.jpg";